import { useEffect, useMemo, useState } from "react";
import InteractionContextMenuItem from "../interaction_context_menu/InteractionContextMenuItem";
import {
  InteractionDefintion,
  SequenceSelectableDefinitions,
} from "../interaction_picker/InteractionDefinitions";
import PiInputfield from "../../components/PiInputField";
import useSequenceContextMenu from "./SequenceContextMenu.hook";
import { OnConnectStartParams } from "@xyflow/react";

interface ContextMenuProps {
  position: { x: number; y: number } | null;
  onAddNode: (definition: InteractionDefintion) => void;
  onClose: () => void;
  pendingConnection: OnConnectStartParams | null;
}

export default function SequenceContextMenu({
  position,
  onAddNode,
  onClose,
  pendingConnection,
}: ContextMenuProps) {
  const { filter, setFilter, filteredOptions, selectedIndex, reset, setOpen } =
    useSequenceContextMenu({ onAddNode, onClose });

  useEffect(() => {
    if (!position) {
      setOpen(false);
      return;
    }

    reset();
    setOpen(true);
  }, [position, setOpen]);

  const filteredOptionsViews = filteredOptions.map(
    (option, index) => {
      return (
        <InteractionContextMenuItem
          key={option.name}
          interactionDefinition={option}
          isSelected={selectedIndex === index}
          onSelect={() => {
            onAddNode(option);
            onClose();
          }}
        />
      );
    },
    [filteredOptions, selectedIndex, onAddNode, onClose]
  );

  const inputfield = useMemo(() => {
    return (
      <PiInputfield
        onChange={setFilter}
        label=""
        placeholder="Search"
        autoFocus
        debounceTime={30}
      />
    );
  }, [filter]);

  if (!position) return null;
  return (
    <>
      {/* Backdrop to close menu when clicking outside */}
      <div className="absolute inset-0 z-[999]" onClick={onClose} />

      <div
        style={{
          position: "absolute",
          left: position.x,
          top: position.y,
          zIndex: 1000,
        }}
        className="bg-creator-surface rounded-lg border border-creator-border shadow-lg p-[12px] select-none flex flex-col gap-[12px] h-[300px] max-h-[300px] overflow-y-auto"
      >
        {inputfield}
        <div className="flex flex-col gap-[4px] h-full overflow-y-auto pit-creator-scrollbar">
          {filteredOptionsViews}
        </div>
      </div>
    </>
  );
}
